export const tokens = {
    // Not actually using these static values.
    // We instead use `em` and allow a customizable `size` prop.
    gap: 4,
    nativePriceSize: 14,
    usdPriceSize: 12,
};
